export default __webpack_public_path__ + "images/0xda10009cbd5d07dd0cecc66161fc93d7c9000da1.png";